{
    "ai_modal_title_1": "Melhore seu texto com IA",
    "ai_modal_title_2": "Gerar novo texto usando IA",
    "ai_description": "Use ferramentas de geração de conteúdo de IA para melhorar seus textos.",
    "ai_learn_more": "Saiba mais",
    "ai_copy_text": "Copiar texto",
    "ai_describe_your_text": "Descreva sobre o que seu texto deve ser",
    "ai_describe_your_text_example": "For example, a small description for a craft shop...",
    "ai_new_request": "Criar nova solicitação",
    "ai_create_text": "Gerar texto",
    "ai_apply_text": "Aplicar texto",
    "ai_try_one_more": "Tente novamente",
    "ai_correct_errors": "Corrigir erros",
    "ai_make_longer": "Estender",
    "ai_make_shorter": "Encurtar",
    "ai_simplify": "Simplificar",
    "ai_business_tone": "Formal",
    "ai_ceremonial_tone": "Festivo",
    "ai_fun_tone": "Alegre",
    "ai_friendly_tone": "Simpático",
    "ai_change_tone": "Alterar o tom de voz",
    "ai_improve_text": "Melhorar o texto",
    "ai_words_number": "Número de palavras:",
    "ai_translate": "Traduzir",
    "ai_translate_to_ru": "Traduzir para russo",
    "ai_translate_to_en": "Traduzir para o inglês",
    "ai_add_creativity": "Adicione criatividade",
    "ai_text_too_large": "Seu texto é muito longo para usar a IA. Torne-o mais curto ou gere um novo texto sobre o tópico desejado com a ajuda da IA.",
    "ai_translate_to_ua": "Traduzir para ucraniano",
    "ai_translate_to_es": "Traduzir para o espanhol",
    "ai_translate_to_pt": "Traduzir para o português",
    "ai_translate_to_tr": "Traduzir para turco",
    "ai_translate_to_fr": "Traduzir para o francês",
    "ai_translate_to_de": "Traduzir para o alemão",
    "ai_translate_to_it": "Traduzir para o italiano",
    "ai_translate_to_pl": "Traduzir para polonês",
    "ai_free_request_error": "As solicitações gratuitas acabaram",
    "ai_free_request_number": "Número da solicitação: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Você pode usar até 200 pedidos gratuitos de ferramentas de IA. Para fazer mais pedidos, ative as suas chaves de API para o provedor AI nas configurações da sua conta.",
    "cancel": "Cancelar",
    "gpt_error_quota": "Você atingiu seu limite de solicitações de API. Para continuar usando as ferramentas de IA, verifique seu limite atual ou adicione fundos ao seu saldo de crédito nas configurações da conta OpenAI.",
    "ai_generated_disclaimer": "Você é responsável pelo texto gerado. Revise-o antes de publicar."
}
